/**
 * @Author: Nemo
 * @Description: 支付表单相关配置
 * @Date: 2024-05-14
 * @FilePath: /rhcn-checkout-web/src/views/aggregate/pc/config.js
 */

// 结账状态枚举
export const CHECKOUT_STATUS = {
  LOADING: 'Loading', // 数据加载中
  FILLING: 'Filling', // 填写表单
  SUBMITTING: 'Processing', // 提交中
  PENDING: 'Pending', // 等待
  ERROR: 'Error', // 报错
  // 终态不能回滚
  // UNKNOWN: 'Unknown', // 未知
  FAILED: 'Failed', // 失败
  SUCCESS: 'Success', // 结束
};

// 支付状态常量
export const PAYMENT_STATUS = {
  INIT: 'INIT',
  SUBMITTING: 'SUBMITTING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  REDIRECT: 'REDIRECT',
  CANCELED: 'CANCELED',
  THREE_D: 'THREE_D',
};

// 支付方式常量
export const PAYMENT_METHOD = {
  CARD: 'CARD',
  LOCAL: 'LOCAL',
  APPLE_PAY: 'ApplePay',
  GOOGLE_PAY: 'GooglePay',
  DANA_VA: 'DANA_VA',
  DOKU_VA: 'DOKU_VA',
  CASH_MY: 'Cash_MY',
  INTERNET_BANKING_MY: 'Internet_Banking_MY',
};

class CheckoutException extends Error {
  constructor({ status, message, others }) {
    super(message);
    this.status = status;
    this.others = others;
  }
}
export { CheckoutException };

export function exceptionShow({ respCode: code, respMsg, data }, isSkipPending = false) {
  // const query = { key, type: checkoutType };
  if ((code === '00020|50054' || code === '50054') && !isSkipPending) { // 订单超时未支付
    // TODO 为什么走pending不是error
    throw new CheckoutException({
      status: CHECKOUT_STATUS.PENDING,
    });
    // query.status = 's0';
    // router.push({
    //   path: '/result/pending',
    //   query,
    // });
    // return true;
  }
  if (code === '00020|50051') { // 成功订单
    throw new CheckoutException({
      status: CHECKOUT_STATUS.SUCCESS,
      message: '',
    });
    // router.push({
    //   path: '/result/success',
    //   query,
    // });
    // return true;
  }
  if (code === '00020|50052') { // 失败订单
    throw new CheckoutException({
      status: CHECKOUT_STATUS.FAILED,
      message: data?.reason || respMsg,
      others: data,
    });
    // router.push({
    //   path: '/result/failed',
    //   query,
    // });
    // return true;
  }
  if (code === '00020|50053') { // 订单已被取消
    throw new CheckoutException({
      status: CHECKOUT_STATUS.ERROR,
      message: '',
    });
    // router.push({
    //   path: '/result/cancelled',
    //   query,
    // });
    // return true;
  }
  if (code === '00020|50050') { // 错误的订单
    throw new CheckoutException({
      status: CHECKOUT_STATUS.ERROR,
      message: '',
    });
    // router.push({
    //   path: '/result/invalid',
    //   query,
    // });
    // return true;
  }
  return false;
}

// Apple Pay语言映射
export const APPLE_PAY_LANG = {
  en: 'en',
  'en-US': 'en',
  'zh-CN': 'zh-CN',
  'zh-HK': 'zh-HK',
  'zh-TW': 'zh-TW',
  ar: 'ar',
  ca: 'ca',
  cs: 'cs',
  da: 'da',
  de: 'de',
  el: 'el',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  he: 'he',
  hu: 'hu',
  id: 'id',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  ms: 'ms',
  nb: 'nb',
  nl: 'nl',
  pl: 'pl',
  pt: 'pt',
  ru: 'ru',
  sk: 'sk',
  sv: 'sv',
  th: 'th',
  tr: 'tr',
};
